"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _breakdancer = _interopRequireDefault(require("./breakdancer"));

var _propget = _interopRequireDefault(require("propget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Small fallback for when the `window` global is not accessible in a given
 * environment. This allows the module to still be used in a regular `node`
 * environment.
 *
 * @type {Object} Window reference or inner{height|width} polyfill.
 * @private
 */
var win = typeof window !== 'undefined' ? window : {
  innerWidth: 1280,
  innerHeight: 768
};
/**
 * Breakdancer is a simple breakpoint utility.
 *
 * @constructor
 * @param {Object} specification Different breakpoints we need to know.
 * @param {Object} windows Option window object reference.
 * @public
 */

var WebDancer =
/*#__PURE__*/
function (_Breakdancer) {
  _inherits(WebDancer, _Breakdancer);

  function WebDancer(specification, windows) {
    var _this;

    _classCallCheck(this, WebDancer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WebDancer).call(this, specification));
    _this.window = windows || win;
    _this.breakpoint = _this.currently();
    return _this;
  }
  /**
   * Return the current view port.
   *
   * @returns {Object} viewport
   * @public
   */


  _createClass(WebDancer, [{
    key: "viewport",
    value: function viewport() {
      return {
        height: this.height(),
        width: this.width()
      };
    }
    /**
     * Lookup the view port width.
     *
     * @returns {Number} Current width.
     * @public
     */

  }, {
    key: "width",
    value: function width() {
      return (0, _propget.default)(this.window, 'innerWidth') || (0, _propget.default)(this.window, 'document.documentElement.clientWidth') || (0, _propget.default)(this.window, 'document.body.clientWidth') || 0;
    }
    /**
     * Lookup the view port height.
     *
     * @returns {Number} Current height.
     * @public
     */

  }, {
    key: "height",
    value: function height() {
      return (0, _propget.default)(this.window, 'innerHeight') || (0, _propget.default)(this.window, 'document.documentElement.clientHeight') || (0, _propget.default)(this.window, 'document.body.clientHeight') || 0;
    }
  }]);

  return WebDancer;
}(_breakdancer.default);

exports.default = WebDancer;